import React from "react";
import * as classNames from "classnames";
import styles from "./inputs.css";

const Input = ({
	type,
	id,
	name,
	value,
	placeholder,
	className,
	onChange,
	onKeyPress,
	disabled = false
}) => {
	const allClassNames = classNames(styles.input, className);

	return (
		<input
			id={id}
			name={name}
			type={type}
			value={value}
			onChange={onChange}
			onKeyPress={onKeyPress}
			placeholder={placeholder}
			className={allClassNames}
			disabled={disabled}
		/>
	);
};

const TextArea = ({
	id,
	name,
	value,
	placeholder,
	disabled = false,
	className,
	onChange
}) => {
	const allClassNames = classNames(styles.textarea, className);

	return (
		<textarea
			id={id}
			name={name}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			className={allClassNames}
			disabled={disabled}
		/>
	);
};

export const TextInput = props => <Input {...props} type="text" />;
export const NumberInput = props => <Input {...props} type="number" />;
export const EmailInput = props => <Input {...props} type="email" />;
export const PasswordInput = props => <Input {...props} type="password" />;
export const MultilineInput = props => <TextArea {...props} />;

export const Label = ({ htmlFor, children }) => {
	return (
		<label className={styles.label} htmlFor={htmlFor}>
			{children}
		</label>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/inputs/inputs.js